import { createContext, useContext, useState } from "react";

const ScanlogContext = createContext();

export const useScanlog = () => useContext(ScanlogContext);

export const ScanlogProvider = ({ children }) => {
    const [allData, setAllData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const token = localStorage.getItem('token');

    const openModalForQr = async (uniqueNo) => {
        try {
            const res = await fetch(`${import.meta.env.VITE_APP_ADMINURL}/api/getScanlogByQrUniqueNo/${uniqueNo}`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                }
            });
            const data = await res.json();
            setAllData(data);
            setShowModal(true);
        } catch (error) {
            console.error("Failed to fetch scanlogs:", error)
        }

    }
    const closeModal = () => setShowModal(false);

    return (
        <ScanlogContext.Provider value={{ allData, showModal, openModalForQr, closeModal }} >
            {children}
        </ScanlogContext.Provider>
    );
}